// JsFromRoutes CacheKey 94300fd03643a2249c2a8e4ada4a9e08
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  noAccess: /* #__PURE__ */ definePathHelper('get', '/public/quotes/:id/no_access'),
  employerCosts: /* #__PURE__ */ definePathHelper('post', '/public/quotes/employer_costs'),
  plansByBenchmark: /* #__PURE__ */ definePathHelper('get', '/public/quotes/plans_by_benchmark'),
  plans: /* #__PURE__ */ definePathHelper('get', '/public/quotes/plans'),
  save: /* #__PURE__ */ definePathHelper('post', '/public/quotes/save'),
  show: /* #__PURE__ */ definePathHelper('get', '/public/quotes/:id'),
}
